/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PartnerType = {
    Partner: 'PARTNER',
    Prospect: 'PROSPECT'
} as const;
export type PartnerType = typeof PartnerType[keyof typeof PartnerType];


export function instanceOfPartnerType(value: any): boolean {
    for (const key in PartnerType) {
        if (Object.prototype.hasOwnProperty.call(PartnerType, key)) {
            if (PartnerType[key as keyof typeof PartnerType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PartnerTypeFromJSON(json: any): PartnerType {
    return PartnerTypeFromJSONTyped(json, false);
}

export function PartnerTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerType {
    return json as PartnerType;
}

export function PartnerTypeToJSON(value?: PartnerType | null): any {
    return value as any;
}

export function PartnerTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PartnerType {
    return value as PartnerType;
}

